import TnButton from './TnButton';

export { TnButton };
